module.exports = __webpack_public_path__ + "static/theoffice-f8fedc12d95b0d9058ead6ba41e96265.gif";